import { render, staticRenderFns } from "./deliverStatistic.vue?vue&type=template&id=e280f766&scoped=true"
import script from "./deliverStatistic.vue?vue&type=script&lang=js"
export * from "./deliverStatistic.vue?vue&type=script&lang=js"
import style0 from "./deliverStatistic.vue?vue&type=style&index=0&id=e280f766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e280f766",
  null
  
)

export default component.exports